export default {
    data() {
        return {
            quantity: 1,
            //Upsell related variables
            skipUpsell: false,
            tyreHasUpsell: false,
            upsellModalOpen: false,
            currentTyre: [],
            upsoldTyre: [],
            upsellDetails: []
        };
    },
    emits: ['modalOpen'],
    methods: {
        deleteFromBasket(st_code) {
            let vm = this;
            axios.post('/ajax/delete_basket_item/' + st_code)
                .then(response => {
                    vm.updatedBasket = response.data.basket;
                    vm.SqueezelyRemoveFromBasket(st_code);
                    vm.emitter.emit('updateBasket', response.data.basket);
                    vm.emitter.emit('updateNavButton', response.data.basket.button);

                    if(response.data.basket.products.length == 0)
                    {
                        vm.modalOpen = false;
                    }

                    vm.removeFromCartSqueezelyTracking(st_code);
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },
        addTyreToBasket(st_code, quantity) {
            //Track basket modal opening
            if(typeof(this.$gtag) !== 'undefined') {
                this.$gtag.event('BasketModal', {
					'event_category' : 'Basket',
					'event_label' : 'Opened'
				});
            }
            else {
                console.log('gtag not loaded');
            }

            // Send to PriceShape
            window.PRICESHAPE = window.PRICESHAPE || [];
            window.PRICESHAPE.itemAddedToCart(String(st_code), quantity);

            //Before adding to the basket we need to check if the tyre has a product upsell assigned to it
            
            //addTyreToBasket is also called from within the UpsellModal itself..
            
            //So close upsell modal first before continuing..
            this.upsellModalOpen = false;

            // check if skipUpsell is false, otherwise skip it and add tyre straight into the basket.
            if(this.skipUpsell == false) {
                this.checkForTyreUpsell(st_code, quantity);
            } else { 
                this.addToBasket(st_code, quantity);
            }

            //After tyre is added, reset skipUpsell
            this.skipUpsell = false;
        },
        checkForTyreUpsell(st_code, quantity) {
            let vm = this;
            var formData = new FormData();

            formData.append('st_code', st_code);
            formData.append('quantity', quantity);

            axios.post('/ajax/tyre_upsell_modal', formData)
            .then(response => {
                if(response.data.upsell_details) {
                    //Set skipUpsell to true so we do not get caught in endless loop
                    vm.skipUpsell = true;

                    //Set current and new tyre data for use within upsellModal
                    vm.currentTyre = response.data.current_tyre;
                    vm.upsoldTyre = response.data.product_to_be_upsold;
                    vm.upsellDetails = response.data.upsell_details;

                    //Launch Upsell modal
                    vm.upsellModalOpen = true;

                    //Track Upsell modal opening
                    if(typeof(this.$gtag) !== 'undefined') {
                        this.$gtag.event('Upsell', {
                            'event_category' : 'Upsell',
                            'event_label' : 'Upsell Modal Opened'
                        });
                    }
                    else {
                        console.log('gtag not loaded');
                    }
                }
                else {
                    //No upsell found, add tyre to basket
                    vm.addToBasket(st_code, quantity);
                }
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        addToBasket(st_code, quantity) {
            let vm = this;
            
            if (st_code != null && st_code != false) {
                st_code = st_code.replace('#', '%23');
            }
            
            axios.post('/ajax/tyres_modal_window/' + st_code + '/' + quantity)
            .then(response => {
                vm.updatedBasket = response.data.basket;
                vm.emitter.emit('updateBasket', response.data.basket);
                vm.addToCartGtag(vm.updatedBasket);
                vm.addToCartSqueezely(vm.updatedBasket);
                vm.addToCartKlaviyo(vm.updatedBasket);
                vm.modalOpen = true;
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        removeFromCartSqueezelyTracking(st_code) {
            window._sqzl = window._sqzl || [];

            window._sqzl.push({
                "event" : "RemoveFromCart",
                "products" : [{
                    "id" : st_code
                }]
            });
        },
        async updateQuantity(event, st_code, loading) {
            let vm = this;
            var quantity = event.target.value;

            if(loading) {
                vm.emitter.emit('isLoading', true);
            }

            if (st_code != null && st_code != false) {
                st_code = st_code.replace('#', '%23');
            }

            await axios.post('/ajax/update_basket_tyre_quantity/' + quantity + '/' + st_code)
            .then(response => {
                if(response.data.basket_updated == true)
                {
                    vm.updatedBasket = response.data.basket;

                    //Update AddToCart events when changing quantity.
                    vm.addToCartGtag(vm.updatedBasket);
                    vm.addToCartSqueezely(vm.updatedBasket);
                    vm.addToCartKlaviyo(vm.updatedBasket);

                    //then globally update basket for basket popover
                    this.emitter.emit('updateBasket', response.data.basket);
                }
            })
            .catch(error => {
                console.error("There was an error!", error);
            });

            if(loading) {
                this.emitter.emit('isLoading', false);
            }
        },
        addServiceToBasket(st_code, quantity, show_loading = true) {
            if(show_loading) {
                //Toggle global loading component
                this.emitter.emit('isLoading', true);
            }

            let vm = this;
            
            if (st_code != null && st_code != false) {
                st_code = st_code.replace('#', '%23');
            }
            var formData = new FormData();

            formData.append('st_code', st_code);
            formData.append('quantity', quantity);

            axios.post('/ajax/add_to_basket', formData)
            .then(response => {
                vm.emitter.emit('updateBasket', response.data.basket);
                vm.emitter.emit('isLoading', false);
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        deleteServiceFromBasket(st_code) {
            //Toggle global loading component
            this.emitter.emit('isLoading', true);

            let vm = this;
            
            if (st_code != null && st_code != false) {
                st_code = st_code.replace('#', '%23');
            }
            
            axios.post('/ajax/delete_basket_item/' + st_code)
            .then(response => {
                vm.emitter.emit('updateBasket', response.data.basket);
                vm.emitter.emit('isLoading', false);
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        async toggleWAInBasket(st_code, removeOnly = false) {
            if(removeOnly) {
                this.deleteServiceFromBasket(st_code);
            }
            else {
                //Toggle global loading component
                this.emitter.emit('isLoading', true);

                //Check if a WA product is already in the basket
                if(this.productInBasket('WHEELALIGNMENT') || this.productInBasket('RCWHEELALIGN4')) {
                    let vm = this;

                    //Remove existing WA product from the basket before adding another.
                    if(this.productInBasket('WHEELALIGNMENT')) {
                        await axios.post('/ajax/delete_basket_item/' + 'WHEELALIGNMENT')
                        .then(response => {
                            vm.addServiceToBasket(st_code, 1, false);
                        });
                    }
                    else if(this.productInBasket('RCWHEELALIGN4')) {
                        await axios.post('/ajax/delete_basket_item/' + 'RCWHEELALIGN4')
                        .then(response => {
                            vm.addServiceToBasket(st_code, 1);
                        });
                    }
                }
                //If not just add the product as normal
                else {
                    this.addServiceToBasket(st_code, 1);
                }
            }
        },
        productInBasket(st_code) {
            if(this.basket.products) {
                let query = this.basket.products.filter((basket_product) => {
                    return (basket_product.st_code == st_code);
                });

                return query.length > 0 ? true : false;
            }
        },
        addToCartGtag(basket) {
            var products = [];
            var basketProduct;

            basket.products.forEach(function (product) {
                basketProduct = {
                    "item_id": product['st_code'],
                    "item_brand" : product['brand'],
                    "item_name" : product['description'],
                    "price": product['retail'],
                    "quantity": product['quantity']
                };
    
                products.push(basketProduct);
            });

            if(typeof(this.$gtag) !== 'undefined') {
                this.$gtag.event('add_to_cart', {
                    currency: "GBP",
                    value: basket.sub_total,
                    items: products
                });
            }
            else {
                console.log('gtag not loaded');
            }
        },
        async addToCartKlaviyo(basket) {
            var _learnq = _learnq || [];

            var products = [];
            var ItemNames = [];
            var basketProduct;
            const parsedUrl = new URL(window.location.href);

            basket.products.forEach(function (product) {
                basketProduct = {
                    "ProductID": product['id'],
                    "SKU": product['st_code'],
                    "ProductName": product['tyre_range'],
                    "Quantity": product['quantity'],
                    "ItemPrice": product['retail'],
                    "RowTotal": product['retail'],
                    "ProductURL": parsedUrl.origin + product['tyre_info_url'],
                    "ImageUrl" : "https://colewood-automotive.s3-eu-west-1.amazonaws.com/Images/" + product['graphic'],
                };

                ItemNames.push(product.tyre_range);
                products.push(basketProduct);
            });

            _learnq.push(["track", "Added to Cart", {
                "$value": basket.sub_total,
                "AddedItemProductName": basket.products[0].tyre_range,
                "AddedItemProductID": basket.products[0].id,
                "AddedItemSKU": basket.products[0].st_code,
                "AddedItemImageURL":"https://colewood-automotive.s3-eu-west-1.amazonaws.com/Images/" + basket.products[0].graphic,
                "AddedItemURL": parsedUrl.origin + basket.products[0].tyre_info_url,
                "AddedItemPrice": basket.products[0].retail,
                "AddedItemQuantity": basket.products[0].quantity,
                "ItemNames": ItemNames,
                "CheckoutURL": parsedUrl.origin + "/booking-details",
                "Items": products
            }]);
        },
        async addToCartSqueezely(basket) {
            window._sqzl = window._sqzl || [];

            var products = [];
            var basketProduct;

            basket.products.forEach(function (product) {
                basketProduct = {
                    "id": product['st_code'],
                    "language": "en-GB",
                    "image_link" : "https://colewood-automotive.s3-eu-west-1.amazonaws.com/Images/" + product['graphic'],
                    "brand" : product['brand'],
                    "title" : product['tyre_range'],
                    "name" : product['tyre_range'],
                    "description" : product['description'],
                    "price": product['retail'],
                    "quantity": product['quantity']
                };
    
                products.push(basketProduct);
            });

            window._sqzl.push({
                "event" : "AddToCart",
                "products" : products,
                "custom_total_price" : basket.sub_total,
                'custom_quantity_tyre_1' : (products[0] ? products[0]['quantity'] : ''),
                'custom_quantity_tyre_2' : (products[1] ? products[1]['quantity'] : '')
            });
        },
        async SqueezelyRemoveFromBasket(stCode) {
            this.emitter.emit('updateSqueezely', {
                "event" : "RemoveFromCart",
                "products" : [{
                    "id" : stCode
                }]
            });
        }
    },
    computed: {
        tyreText() {
            return this.inBasket ? 'In Basket' : 'Buy';
        },
        buttonColour() {
            return this.inBasket ? 'bg-dark-blue' : 'green-bg';
        },
        tyreBorder() {
            let border = 'grey';

            if(this.inFeatured) {
                border = 'blue';
            }
            if(this.inBasket)
            {
                border = 'blue';
            }

            return border;
        },
        showBanner() {
            if(typeof(this.banners) != 'undefined' && Object.keys(this.banners).length > 0) {
                let banner = this.banners.filter((banner) => {
                    return banner.qualifying_products.includes(this.tyre.st_code)
                });
                
                return banner.length ? true : false;
            }
        },
        inFeatured: function() {
            let vm = this;
            if(this.$parent.featuredTyres) {
                let items = this.$parent.featuredTyres;
                
                let result = Object.keys(items).map(key => items[key]).filter((item) => {
                    return item.st_code == vm.tyre.st_code;
                });
                
                //Checks to see if the tyre is in the Featured Tyres section, or if the Featured Top Spot flag is true
                return result.length > 0 || (vm.featuredTopSpotFlag != null && vm.featuredTopSpotFlag == true) ? true : false;
            }
        },
        inBasket: function() {
            if(typeof(this.updatedBasket) != 'undefined' && typeof(this.updatedBasket.products) != 'undefined' && Object.keys(this.updatedBasket.products).length > 0) {
                let query = this.updatedBasket.products.filter((basket_product) => {
                    return (basket_product.st_code == this.tyre.st_code);
                });

                return query.length > 0 ? true : false;
            }
        }
    }
};